import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface INameField {
	changeName: (value: string) => void;
}

const NameField: React.FC<INameField> = ({ changeName }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterName') }], [t]);

	return (
		<FormInput
			testId="NameField"
			name="name"
			label="nameOfModifierLabel"
			onChange={changeName}
			validationRules={validationRules}
			maxLength={100}
		/>
	);
};

export default React.memo(NameField);
